import { FC } from "react";
import { useControls } from "react-zoom-pan-pinch";

const FacilityMapZoomControls: FC = () => {
  const { zoomIn, zoomOut, resetTransform } = useControls();

  return (
    <div className="absolute right-4 top-4 z-10 flex flex-col gap-1.5">
      <button
        type="button"
        onClick={() => zoomIn(0.5)}
        aria-label="Zoom in"
        className="flex size-10 items-center justify-center rounded-full border border-white/[0.08] bg-white/[0.04] text-white/70 backdrop-blur-sm transition-colors hover:bg-white/[0.08] hover:text-white"
      >
        <svg
          className="size-5"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={2}
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 4.5v15m7.5-7.5h-15"
          />
        </svg>
      </button>
      <button
        type="button"
        onClick={() => zoomOut(0.5)}
        aria-label="Zoom out"
        className="flex size-10 items-center justify-center rounded-full border border-white/[0.08] bg-white/[0.04] text-white/70 backdrop-blur-sm transition-colors hover:bg-white/[0.08] hover:text-white"
      >
        <svg
          className="size-5"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={2}
          stroke="currentColor"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 12h-15" />
        </svg>
      </button>
      <button
        type="button"
        onClick={() => resetTransform()}
        className="flex size-10 items-center justify-center rounded-full border border-white/[0.08] bg-white/[0.04] text-[10px] font-bold uppercase tracking-wider text-white/70 backdrop-blur-sm transition-colors hover:bg-white/[0.08] hover:text-white"
      >
        Fit
      </button>
    </div>
  );
};

export default FacilityMapZoomControls;
